import message from "../../shared/assets/message-question.svg";
import { themeAtom } from "../../shared/atoms";
import { SupportContactModal } from "./SupportContactModal";
import { useAtomValue } from "jotai";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

export const ContactSupport: React.FC<{}> = () => {
  const theme = useAtomValue(themeAtom);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={twMerge(
          "flex gap-4 rounded-lg border border-green p-6",
          theme.headerComponent.notifications.itemBackground,
        )}
      >
        <img src={message} alt="Description" className="size-6" />
        <div className="flex items-center gap-8">
          <div className="flex flex-col gap-1">
            <div className={twMerge("font-bold", theme.headerComponent.notifications.headerText)}>
              Seeking Assistance?
            </div>
            <p className={theme.uwhcAssistant.text}>
              If you have any issue while navigating the dashboard, our team is here to assist you. Contact our support
              team for assistance.
            </p>
          </div>
          <button
            type="button"
            onClick={() => setIsModalOpen(true)}
            className="cursor-pointer text-nowrap px-4 py-2 text-sm font-semibold text-green"
          >
            Contact support
          </button>
        </div>
      </div>

      {isModalOpen && <SupportContactModal onClose={() => setIsModalOpen(false)} />}
    </>
  );
};
